<div class="dialog-container">
  <div class="header">
    <h2 class="title">{{ data?.header }}</h2>
    <button mat-icon-button (click)="onCloseClick(false)">
      <mat-icon svgIcon="ak-close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>{{ data?.message }}</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="onCloseClick(true)">
      {{ data?.rejectButtonLabel }}
    </button>
    <button mat-flat-button color="primary" (click)="onConfirmationClick()">
      {{ data?.confirmButtonLabel }}
    </button>
  </mat-dialog-actions>
</div>
